<dynamic-view-v2
    *ngIf="!isLoading"
    entityType="qa-users"
    [viewName]="title"
    [record]="QAUserRecord"
    [fields]="fields"
    [showLocalizedValuesButton]="true"
>
</dynamic-view-v2>